import React, { useContext, useEffect, useRef } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { objectiveContext } from "../../../context/Objective";

gsap.registerPlugin(ScrollTrigger);

const data = [
  {
    id: 1,
    count: "01",
    heading: "SMART CITIES",
    title: "Put insights into action",
    bgImg: "bg-[url(/public/assets/smartcity.jpg)]",
    path: "/solutions/smart-cities",
  },
  {
    id: 2,
    count: "02",
    heading: "CRITICAL INFRASTRUCTURE",
    title: `Putting digital twins to work`,
    bgImg: "bg-[url(/public/assets/criticalinfrastructure.jpg)]",
    path: "/solutions/critical-infrastructure",
  },
  {
    id: 3,
    count: "03",
    heading: "REAL ESTATE",
    title: `Seeing is Believing`,
    bgImg: "bg-[url(/public/assets/realestate.jpg)]",
    path: "/solutions/real-estate",
  },
  {
    id: 4,
    count: "04",
    heading: "CYBER SECURITY",
    title: `Security Services for the Metaverse`,
    bgImg: "bg-[url(/public/assets/cybersecurity.jpg)]",
    path: "/solutions/cyber-security",
  },
  {
    id: 5,
    count: "05",
    heading: "HEALTH CARE",
    title: ` Revolutionizing the Healthcare Industry`,
    bgImg: "bg-[url(/public/assets/healthcare.png)]",
    path: "/solutions/health-care",
  },
];

const cardStyle =
  "grow-0 shrink-0 cursor-pointer basis-[20%] px-[25px] flex flex-col justify-center relative bg-no-repeat bg-cover bg-center z-[1] before:content-[''] before:bg-[#000000bf] before:w-full before:h-full before:absolute before:top-0 before:left-0 before:z-[-1] max-[1200px]:basis-[100%] max-[1200px]:pt-[20px] max-[1200px]:pb-[80px]";

const plusSign =
  "absolute bottom-[30px] left-[20px] text-[white] bg-[black] w-[30px] flex items-center justify-center h-[30px] max-[1199px]:left-[48.5%]";

const countingStyle = "text-[white] font-semibold text-[12px]";

function CategoriesMobile() {
  const { setCompanyActive, setSolutionActive } = useContext(objectiveContext);

  const catRef = useRef([]);
  const headingRef = useRef([]);
  const hideHeadingRef = useRef([]);
  const signRef = useRef([]);
  catRef.current = [];
  headingRef.current = [];
  hideHeadingRef.current = [];
  signRef.current = [];

  const addToCatRef = (el) => {
    if (el && !catRef.current.includes(el)) {
      catRef.current.push(el);
    }
  };

  const addToHideHeadingRef = (el) => {
    if (el && !hideHeadingRef.current.includes(el)) {
      hideHeadingRef.current.push(el);
    }
  };

  const addToHeadingRef = (el) => {
    if (el && !headingRef.current.includes(el)) {
      headingRef.current.push(el);
    }
  };

  // animation
  useEffect(() => {
    catRef.current.forEach((element, index) => {
      headingRef.current.forEach((heading, headingIndex) => {
        if (headingIndex === index) {
          gsap.to(heading, {
            duration: 1,
            autoAlpha: 1,
            ease: "power4.in",
            scrollTrigger: {
              trigger: element,
              toggleActions: "play none none none",
              start: "top bottom-=30px",
            },
          });
        }
      });
    });
  });
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        setCompanyActive(false);
        setSolutionActive(false);
      }}
      className="w-full min-h-[100vh] flex flex-wrap"
    >
      {data.map((item) => {
        return (
          <div
            key={item.id}
            className={`relative ${cardStyle} categories_card bg-cover ${item.bgImg}`}
            ref={addToCatRef}
            onClick={() => {
              navigate(item.path);
              window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
            }}
          >
            <div className="max-[1199px]:text-center">
              <div className={countingStyle}>{item.count}</div>
              <div className="relative text-[white] font-bold text-[22px] mb-2 mt-2">
                <div ref={addToHideHeadingRef}>{item.heading}</div>
                <div
                  className="!capitalize font-medium text-[18px]"
                  ref={addToHeadingRef}
                  style={{ opacity: 0 }}
                >
                  {item.title}
                </div>
              </div>
            </div>
            <Link to={item.path}>
              <div
                onClick={() =>
                  window.scrollTo({ top: 0, left: 0, behaviour: "smooth" })
                }
                className={plusSign}
              >
                <PlusOutlined />
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
}

export default CategoriesMobile;
